<mat-card>
    <mat-card-content fxLayout fxLayoutAlign="center center" fxLayoutGap="20px">
        <mat-form-field>
            <mat-label>Product</mat-label>
            <mat-select [(value)]="selectedProduct" (selectionChange)="productChange($event)">
                <mat-option *ngFor="let product of products" [value]="product">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <div class="m-r-10 chart-select-color" [style.background-color]="product.productColor"></div>
                        <div>{{product.product}}</div>
                    </div>
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Environment</mat-label>
            <mat-select [(value)]="selectedEnvironment" (selectionChange)="environmentChange($event)">
                <mat-option *ngFor="let environmentSettings of environments" [value]="environmentSettings">
                    {{EnvironmentNameEnum[environmentSettings.environment.environment]}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </mat-card-content>
</mat-card>

<mat-card *ngIf="selectedEnvironment" class="environment">
    <mat-card-content>
        <mat-form-field class="defaultCuttoffDate">
            <mat-label>Cut-off Date</mat-label>
            <input matInput (ngModelChange)="changeOccurred()" [matDatepicker]="cuttoffDatePicker"
                placeholder="Choose a date & time" [(ngModel)]="selectedEnvironment.defaultCuttoffDate"
                [disabled]="EnvironmentNameEnum[selectedEnvironment.environment.environment] == 'Latest' || !allowEdit" />
            <mat-datepicker-toggle matSuffix [for]="cuttoffDatePicker"></mat-datepicker-toggle>
            <mat-datepicker type="datetime" #cuttoffDatePicker>
                <mat-datepicker-actions>
                    <button mat-button matDatepickerCancel>Cancel</button>
                    <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                </mat-datepicker-actions>
            </mat-datepicker>
            <mat-hint>{{ selectedEnvironment.defaultCuttoffDate | date:'mediumDate' }}</mat-hint>
            <button *ngIf="selectedEnvironment.defaultCuttoffDate && allowEdit" matSuffix mat-icon-button
                aria-label="Clear" (click)="clearCutoffDate(environment)">
                <mat-icon>close</mat-icon>
            </button>
        </mat-form-field>
    </mat-card-content>
</mat-card>

<mat-card *ngIf="selectedEnvironment" class="environment">
    <div *ngIf="overridesLoading">
        <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
    </div>
    <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px"
            fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
            <label>Overrides</label>
            <button *ngIf="admin" [@cardAnimator]="animateAddOverride"
                (@cardAnimator.done)="resetAddOverrideAnimationState()" matTooltip="Add Override" mat-flat-button
                color="accent" (click)="onClickAddOverride()">
                <mat-icon>add</mat-icon> Add Override
            </button>
        </div>
        <mat-card *ngIf="selectedEnvironment?.overrides?.length > 0" class="contrast"
            [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
            <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
                <mat-form-field>
                    <input matInput type="text" [formControl]="searchField" (keyup)="doFilter($event.target.value)"
                        (keyup.esc)="$event.target.value=''; doFilter('')"
                        placeholder="Filter overrides by caller reference key">
                </mat-form-field>
            </mat-card-content>
        </mat-card>
        <ng-container *ngFor="let item of filteredOverrides; let i = index">
            <mat-card *ngIf="expandedOverridesList || i < 12" class="contrast"
                [ngClass.lt-lg]="{'mat-card-inline-sm': true}">
                <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
                    <div fxFlex="75" fxLayoutAlign="start center" fxLayout="row">
                        <strong [ngClass.lt-sm]="{'card-title': true}"
                            [innerHtml]="item?.callerReferenceKey | encodeHtml | highlight: searchField.value"></strong>
                    </div>
                    <div fxFlex="25" fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column"
                        fxLayoutGap="10px" fxLayoutGap.lt-sm="18px">
                        <div fxLayoutAlign="end center" fxLayout="row" fxLayout.lt-sm="column"
                            fxLayoutAlign.lt-sm="center center" class="date-text">
                            <span class="text-info">v{{ item?.version}}</span>
                        </div>
                        <div fxLayoutAlign="end center" fxLayout="row" fxLayoutGap="10px">
                            <button mat-mini-fab matTooltip="Edit Override" color="accent" aria-label="Edit Override"
                                (click)="onClickEditOverride(item?.id);">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button mat-mini-fab matTooltip="Remove" color="warn" aria-label="Remove"
                                (click)="onClickDeleteOverride(item?.id);">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </ng-container>
        <mat-card *ngIf="selectedEnvironment?.overrides?.length > 0" class="contrast card-link banner-info"
            [ngClass.lt-lg]="{'mat-card-inline-sm': true}" (click)="toggleExpandedOverridesList()">
            <mat-card-content fxLayoutAlign="center center" fxLayout="row" fxLayout.lt-sm="column">
                <div fxFlex="100" fxLayoutAlign="center center" fxLayout="row">
                    <strong *ngIf="!expandedOverridesList" class="text-center"
                        [ngClass.lt-sm]="{'card-title': true}"><mat-icon>expand_more</mat-icon></strong>
                    <strong *ngIf="expandedOverridesList" class="text-center"
                        [ngClass.lt-sm]="{'card-title': true}"><mat-icon>expand_less</mat-icon></strong>
                </div>
            </mat-card-content>
        </mat-card>
    </mat-card-content>
</mat-card>